/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import { ENTER_KEY, ENTER_KEYCODE, SPACE_KEY, SPACE_KEYCODE } from '../constants/keyCodes';

// called when user keydown on the previous or next arrows
export const handleArrowKeydown = (e, handler) => {
  const isEnterPressed = e.key === ENTER_KEY || e.keyCode === ENTER_KEYCODE;
  const isSpacePressed = e.key === SPACE_KEY || e.keyCode === SPACE_KEYCODE;
  if (isEnterPressed || isSpacePressed) {
    handler();
  }
};

export const updateAccessibilityForApptDateSlider = () => {
  // added timeout to allow for timing issue seen when updating the appt cards properties
  setTimeout(() => {
    // find slider item in the appt dates slider
    const dateSlides = document.getElementsByClassName('slick-slide');
    // add aria-hidden property to each slider to help w/ accessibility
    for (let index = 0; index < dateSlides.length; index++) {
      const element = dateSlides[index];
      element.setAttribute('aria-hidden', false);
    }

    // Focus first available date card after carousel renders
    // Use querySelectorAll and get the LAST carousel (most recently added) to handle reschedule flow
    const carouselContainers = document.querySelectorAll('.appointment-date-carousel-wrapper');
    const carouselContainer = carouselContainers[carouselContainers.length - 1];
    if (carouselContainer) {
      const firstAvailableCard = carouselContainer.querySelector(
        '.appointment-date-wrapper:not(.disabled)'
      );
      if (firstAvailableCard) {
        firstAvailableCard.focus();
      }
    }
  }, 300);
};
